module.exports = __webpack_public_path__ + "img/logo.8ee0bab1.png";